export default {
  words_cloud: [],
  pagination: {},
  word_cloud: {}
}
